import clsx from "clsx";

import { wrapStringInSpan } from "@utils/index";

export const SearchFaqItem = ({
  category,
  title,
  text,
  searchValue = "",
  noHover,
}: {
  category: string;
  title: string;
  text: string;
  searchValue?: string;
  noHover?: boolean;
}) => {
  const formattedTitle = wrapStringInSpan(title, searchValue);
  const formattedText = wrapStringInSpan(text, searchValue);

  return (
    <a
      href={`#${category}---${title}`}
      className={clsx(
        "block px-6 pb-1.5 pt-0.5",
        !noHover && "cursor-pointer hover:bg-black-4",
      )}
    >
      <div
        className="text-300 font-bold text-black-100 *:bg-primary-108 *:text-magenta-200"
        dangerouslySetInnerHTML={{ __html: formattedTitle }}
      />
      <div
        className="text-100 text-black-54 *:bg-primary-108 *:text-magenta-200"
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
    </a>
  );
};
